import { render, staticRenderFns } from "./DeviceAlert.vue?vue&type=template&id=1dc9a40c&scoped=true"
import script from "./DeviceAlert.vue?vue&type=script&lang=js"
export * from "./DeviceAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc9a40c",
  null
  
)

export default component.exports